export default __webpack_public_path__ + "static/media/InactiveDownArrow.5f858d63.svg";